import type { CurrencyCode } from "@nexus/contracts";

const DEFAULT_CURRENCY_CODE: CurrencyCode = "USD";

const CURRENCY_SYMBOLS: Record<CurrencyCode, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  ILS: "₪",
  AUD: "$",
  CAD: "$",
  JPY: "¥",
};

export const CURRENCY_DROPDOWN_OPTIONS: ReadonlyArray<{ code: CurrencyCode; label: string }> = [
  { code: "USD", label: "USD ($)" },
  { code: "EUR", label: "EUR (€)" },
  { code: "GBP", label: "GBP (£)" },
  { code: "ILS", label: "ILS (₪)" },
  { code: "AUD", label: "AUD ($)" },
  { code: "CAD", label: "CAD ($)" },
  { code: "JPY", label: "JPY (¥)" },
] as const;

export function isCurrencyCode(value: string): value is CurrencyCode {
  return Object.prototype.hasOwnProperty.call(CURRENCY_SYMBOLS, value);
}

export function resolveCurrencyCode(value: string | null | undefined): CurrencyCode {
  if (!value) return DEFAULT_CURRENCY_CODE;
  return isCurrencyCode(value) ? value : DEFAULT_CURRENCY_CODE;
}

export function currencySymbolForCode(code: string | null | undefined): string {
  return CURRENCY_SYMBOLS[resolveCurrencyCode(code)];
}

export function currencyLabelForCode(code: string | null | undefined): string {
  const resolved = resolveCurrencyCode(code);
  return CURRENCY_DROPDOWN_OPTIONS.find((option) => option.code === resolved)?.label ?? "USD ($)";
}
